module.exports = __webpack_public_path__ + "static/media/Rotessa-instant-bank-verification.a8e02121.png";